export default function GradientFade() {
	return (
		<div
			aria-hidden="true"
			className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none bg-gradient-to-t from-white to-transparent transition-opacity duration-300"
		/>
	)
}
